import { useEffect, useState } from 'react'

const CACHED_API_KEY_NAME = 'BEAM_WIDGET_API_KEY'
export function useWidgetApiKey() {
  const cachedApiKey = localStorage.getItem(CACHED_API_KEY_NAME) || undefined
  const [apiKey, setApiKey] = useState(cachedApiKey)

  useEffect(() => {
    apiKey
      ? localStorage.setItem(CACHED_API_KEY_NAME, apiKey)
      : localStorage.removeItem(CACHED_API_KEY_NAME)
  }, [apiKey])

  return [apiKey, setApiKey] as const
}
